/**
 * =============================================================================
 * DEBUG_TEMP - TEMPORARY DEBUG FLAG FOR PRODUCTION DEBUGGING
 * =============================================================================
 * 
 * WARNING: This file enables debug features in production for troubleshooting.
 * 
 * HOW TO DISABLE AFTER FIXING THE ISSUE:
 * 1. Set DEBUG_ENABLED_IN_PRODUCTION = false
 * 2. Search for "DEBUG_TEMP" across the codebase to find all related changes
 * 3. Revert all DEBUG_TEMP marked code blocks
 * 
 * Files modified for DEBUG_TEMP:
 * - client/src/config/debug-temp.ts (this file)
 * - client/src/services/performance-monitor.ts
 * - client/src/components/developer-settings.tsx
 * 
 * Created: 2024-12-28 for production empty data debugging
 * =============================================================================
 */

// DEBUG_TEMP: Set to true to enable debug features in production
// Change to false when done debugging
// DISABLED: Root cause found - drizzle-kit push was deadlocking production server
export const DEBUG_ENABLED_IN_PRODUCTION = false;

// Helper function to check if debug should be active
// Returns true if: in development mode OR DEBUG_ENABLED_IN_PRODUCTION is true
export function isDebugAllowed(): boolean {
  // DEBUG_TEMP: Allow debug in production when flag is set
  if (DEBUG_ENABLED_IN_PRODUCTION) return true;
  return import.meta.env.MODE === 'development';
}

// Console log to make it obvious debug mode is active
if (DEBUG_ENABLED_IN_PRODUCTION && import.meta.env.MODE === 'production') {
  console.warn('[DEBUG_TEMP] ⚠️ Production debug mode is ENABLED. Remember to disable after debugging.');
}
